import { Box } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useEffect, useRef, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { Loader } from "./components/common/Loader/Loader";
import { Footer } from "./components/common/Footer/Footer";
import { Header } from "./components/common/Header/Header";
// import PreventBackNavigation from "./pages/PreventBackNavigation";
import { setTitle } from "./redux/actions/dashboardTitle";
import { checkTokenExpiry } from "./utils/authUtils";
import MainContent from "./components/MainContent/MainContent";
import LandingPage from "./components/LandingPage/LandingPage";
import PrivateRoutes from "./routes/PrivateRoutes";
// import { getHeaderRoles } from "./redux/actions/HeaderRoles/GetHeaderRolesSlice";
// import { ModuleRegistry } from "ag-grid-community";
// import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";



const theme = createTheme( {
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {

          '&.Mui-focused .MuiOutlinedInput-notchedOutline ': {
            borderColor: '#000',  // Your desired border color
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            borderColor: '#000',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#000',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#000',
          },
        },
      },
    },
    MuiMultiSectionDigitalClockSection: {
      styleOverrides: {
        item: {
          "&.Mui-selected": {
            backgroundColor: '#000',
          },
          "&.Mui-selected:hover": {
            backgroundColor: '#797979'
          }
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#797979'
        },
      },
    },

  },
} );

function App() {
  // Set the document title
  useEffect( () => {
    document.title = "Autonomous Layer Root";
  }, [] );

  const constraintMenuItems = [
    {
      id: 1,
      path: "/landing-page",
      title: "Landing",
    }
  ];

  return (
    // (isAuthenticated && accounts?.[0] && !loaderFlag) ?
    <Box
      sx={ {
        margin: "auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      } }
    >
      {/* <PreventBackNavigation /> */ }
      <ThemeProvider theme={ theme }>
        <Header
          // headerRef={useRef()}
          title="AL App Root"
          handleLogout={ () => { } }
          handleMenuItemClick={ () => { } }
          storedRoles=""
        />
        <Box
          sx={ {
            display: "flex",
            flex: 1,
            transition: "padding-top 0.3s ease",
          } }
        >
          {/* <LandingPage/> */ }
          <MainContent />
        </Box>
        <Footer />
        <ToastContainer />
      </ThemeProvider>
    </Box>

  );
}

export default App;
